
import { Link } from 'react-router-dom';
import S from './style'
import TranslateStatic from '../../locales/TranslateStatic';
import { LocaleContext } from '../../locale-context';
import AzimeIMG from '../../assets/ekip/azime-evci.png'
export function Azime() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="AzimeUnvan" /> Dr. Azime Evci</h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="teamHeader" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="profile-card">
          <div className="profile-sidebar">
            <div className="avatar-wrapper">
              <img src={AzimeIMG} alt="Dr. Azime Evci" />
            </div>
            <h2><TranslateStatic string="AzimeUnvan" /> Dr. Azime Evci</h2>
            <div className="tags">
              <span className="badge primary"><TranslateStatic string="Azime" /></span>
            </div>
          </div>
          <div className="profile-body">
            <div className="cv-body">
        <LocaleContext.Consumer>
          {(value) => {
            if (value === "tr") {
              return <div>
                <h3>Kişisel Bilgiler</h3>

                <p>Dr Azime Evci 1969 yılında Isparta’da dogdu.
                  İlk ve orta öğrenimini Gönen/Guneykent ilköğretim okulunda tamamladı.
                  1983-1986 yılları arasinda Nevsehir Kız Öğretmen Lisesinde okudu.
                  1986 yılında Cumhuriyet Üniversitesi Tıp Fakultesinde başladığı tıp eğitimini, 1989
                  yılından itibaren Akdeniz Üniversitesi Tıp Fakultesinde sürdürerek 1992 yılında mezun
                  oldu.</p>
                <p>Mezuniyet sonrasında Giresun, Isparta ve Bolu / Gerede’de çalıştı.
                  1998-2003 yılları arasında Akdeniz Üniversitesi Anesteziyoloji ve Reanimasyon Anabilim
                  Dalında uzmanlık eğitimini tamamladı.</p>
                Uzman olduktan sonra Antalya Anadolu Hastanesi ve Alanya Egitim Araştırma
                Hastanesinde görev yaptı.
                Halen Gelecek Tüp Bebek Merkezinde anestezi uzmanı olarak çalışmaktadır.


              </div>

            }
            else if (value === 'en') {
              return <div>
                <h3>Personal Information</h3>

                <p>Dr.Evci was born in Isparta in 1969. She completed her primary and secondary education at Guneykent,Isparta.
                  She graduated from high school in Nevşehir in 1986.
                  She started her medical education in 1986 at Cumhuriyet University in Sivas and moved to Antalya where she graduted from Akdeniz University in 1992.</p>
                <p>After graduation she worked in Giresun,Isparta and Bolu before
                  specialization.</p>
                She completed her specialization in the Department of Anesthesiology and
                Reanimation between 1998 and 2003 at Akdeniz Universty.
                Then she worked at Antalya Anatolia Hospital and,Alanya Training and Research Hospitals. She is currently working in invitro fertilization center.(Future-Gelecek).



              </div>
            }
            else if (value === 'ru') {
              return <div>
                <h3>Личные данные</h3>

                <p>Доктор Азиме Эвджи родилась в 1969 году в Испарте.
                  Начальное и среднее образование получила в начальной школе Гёнен/Гюнейкент.
                  В период с 1983 по 1986 год училась в Невеширском женском учительском лицее.
                  В 1986 году начала медицинское образование на медицинском факультете Университета Чукурова, с 1989 года продолжила обучение на медицинском факультете Университета Акдениз, который окончила в 1992 году.</p>

                <p>После окончания университета работала в Гиресуне, Испарте и Болу/Гереде.
                  В период с 1998 по 2003 год прошла специализацию по анестезиологии и реаниматологии на медицинском факультете Университета Акдениз.</p>

                <p>После получения специализации работала в больнице Анталья Анадолу и учебно-исследовательской больнице Аланьи.
                  В настоящее время работает специалистом по анестезиологии в Центре ЭКО "Гелек".</p>

              </div>
            }
            else if (value === 'ar') {
              return <div>
                <h3>المعلومات الشخصية</h3>

                <p>الدكتورة عظيمه إيفجي وُلِدت عام 1969 في إسبارطة.
                  أتمت تعليمها الابتدائي والمتوسط في مدرسة جونين/جونيكنت الابتدائية.
                  في الفترة ما بين 1983-1986 درست في ثانوية نيفشير للبنات للمعلمات.
                  بدأت تعليمها الطبي في كلية الطب بجامعة الجمهورية عام 1986، واستكملت دراستها من عام 1989 في كلية الطب بجامعة أكدنيز وتخرجت عام 1992.</p>

                <p>بعد التخرج عملت في غيرسون، إسبارطة وبولو/غيريده.
                  في الفترة ما بين 1998-2003 أكملت تخصصها في قسم التخدير والعناية المركزة بكلية الطب جامعة أكدنيز.</p>

                <p>بعد حصولها على التخصص عملت في مستشفى أنطاليا أناضولو ومستشفى ألانيا التعليمي والبحثي.
                  تعمل حاليًا كأخصائية تخدير في مركز جيليك لأطفال الأنابيب.</p>
              </div>
            }
            else if (value === 'uz') {
              return <div>
                <h3>Shaxsiy Ma'lumotlar</h3>

                <p>Doktor Azime Evji 1969 yilda Isparta shahrida tug'ilgan.
                  Boshlang'ich va o'rta ta'limini Gönen/Güneykent boshlang'ich maktabida tamomlagan.
                  1983-1986 yillari orasida Nevşehir Qizlar O'qituvchilar Litseyida o'qigan.
                  1986 yilda Chukurova Universiteti Tibbiyot Fakultetida tibbiyot ta'limini boshlab, 1989 yildan boshlab Akdeniz Universiteti Tibbiyot Fakultetida davom ettirib, 1992 yilda tamomlagan.</p>

                <p>Universitetni tamomlagandan so'ng Giresun, Isparta va Bolu/Gerede shaharlarida ishlagan.
                  1998-2003 yillari orasida Akdeniz Universiteti Anesteziyologiya va Reanimatsiya kafedrasida mutaxassislik ta'limini tamomlagan.</p>

                <p>Mutaxassislikni olgandan so'ng Antaliya Anadolu kasalxonasi va Alanya Ta'lim-Tadqiqot kasalxonasida ishlagan.
                  Hozirda Gelecek Nogiron Bolalar Markazida anesteziolog mutaxassisi sifatida ishlaydi.</p>

              </div>
            }
          }}
        </LocaleContext.Consumer>

            </div>
          </div>
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
